import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { authGuard } from './auth/guards/auth.guard';
import { AcessoNegadoComponent } from './core/acesso-negado/acesso-negado.component';
import { AssinaturaGuard } from './dashboard/services/assinatura.guard';
import { LayoutComponent } from './layout/layout/layout.component';
import { AssinaturaPageComponent } from './view/outros/assinatura-page/assinatura-page.component';

const routes: Routes = [
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [authGuard],
  },
  {
    path: 'cadastros',
    loadChildren: () =>
      import('./view/cadastros/cadastros.module').then(
        (m) => m.CadastrosModule
      ),
    canActivate: [authGuard],
  },
  {
    path: 'financeiro',
    loadChildren: () =>
      import('./view/financeiro/financeiro.module').then(
        (m) => m.FinanceiroModule
      ),
    canActivate: [authGuard],
  },
  {
    path: 'comercial',
    loadChildren: () =>
      import('./view/comercial/comercial.module').then(
        (m) => m.ComercialModule
      ),
    canActivate: [authGuard],
  },
  {
    path: 'suprimentos',
    loadChildren: () =>
      import('./view/suprimentos/suprimento.module').then(
        (m) => m.SuprimentoModule
      ),
    canActivate: [authGuard],
  },
  {
    path: 'fiscal',
    loadChildren: () =>
      import('./view/fiscal/fiscal.module').then((m) => m.FiscalModule),
    canActivate: [authGuard],
  },
  {
    path: 'contabil',
    loadChildren: () =>
      import('./view/contabil/contabil.module').then((m) => m.ContabilModule),
    canActivate: [authGuard],
  },
  {
    path: 'gerencial',
    loadChildren: () =>
      import('./view/gerencial/gerencial.module').then(
        (m) => m.GerencialModule
      ),
    canActivate: [authGuard],
  },
  {
    path: 'configuracoes',
    loadChildren: () =>
      import('./view/configuracao/configuracao.module').then(
        (m) => m.ConfiguracaoModule
      ),
    canActivate: [authGuard],
  },
  {
    path: 'relatorios',
    loadChildren: () =>
      import('./view/relatorios/relatorios.module').then(
        (m) => m.RelatoriosModule
      ),
    canActivate: [authGuard],
  },
  {
    path: 'assinatura',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: AssinaturaPageComponent,
        canActivate: [AssinaturaGuard],
      },
    ],
  },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'acesso-negado', component: AcessoNegadoComponent },
  // { path: 'pagina-nao-encontrada', component: PaginaNaoEncontradaComponent },
  // { path: '**', redirectTo: 'pagina-nao-encontrada' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
